import { makeStyles } from "@material-ui/core"

export default makeStyles({ 
    buttonGroup: { 
        textAlign: 'center', 
        marginTop: 10
    }
}); 